export const SubsidyExtras = ({ scheme }) => (
  <>
    {scheme.projectCategories && (
      <section className="py-16 bg-[#f8fafc]">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <h2 className="font-heading text-2xl font-semibold text-[#0f172a] mb-8 text-center">
            Project Categories
          </h2>
          <div className="overflow-x-auto">
            <table className="w-full bg-white rounded-xl overflow-hidden shadow-sm">
              <thead className={`bg-gradient-to-r ${scheme.color} text-white`}>
                <tr>
                  <th className="px-6 py-4 text-left font-medium">Category</th>
                  <th className="px-6 py-4 text-left font-medium">Min Investment</th>
                  <th className="px-6 py-4 text-left font-medium">Key Incentive</th>
                </tr>
              </thead>
              <tbody>
                {scheme.projectCategories.map((cat, index) => (
                  <tr key={index} className="border-b border-slate-100 last:border-0">
                    <td className="px-6 py-4 font-medium text-[#0f172a]">{cat.category}</td>
                    <td className="px-6 py-4 text-[#64748b]">{cat.investment}</td>
                    <td className="px-6 py-4 text-[#64748b]">{cat.keyIncentive}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </section>
    )}

    {scheme.infrastructure && (
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <h2 className="font-heading text-2xl font-semibold text-[#0f172a] mb-8 text-center">
            Supported Infrastructure
          </h2>
          <div className="flex flex-wrap justify-center gap-3">
            {scheme.infrastructure.map((item, index) => (
              <span
                key={index}
                className="px-4 py-2 bg-[#f8fafc] border border-slate-200 rounded-full text-sm text-[#0f172a]"
              >
                {item}
              </span>
            ))}
          </div>
        </div>
      </section>
    )}
  </>
);
